import { client, appclient } from "./index";


export const getRequestList = (token, payload) => {
    const queryParams = Object.entries({
        page_number: payload?.page_number,
        page_size: payload?.page_size,
        job_details_id: payload?.job_details_id,
        request_id: payload?.request_id,
        date_range: payload?.date_range,
        job_name: payload?.job_name,
        priority: payload?.priority,
        status: payload?.status,
        Primary_Basin: payload?.Primary_Basin
    })
        .filter(([_, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

    return appclient.get(`resupply_dashboard_ops?${queryParams}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
export const getRequestOverView = (token, payload) =>
    appclient.get(`Request_general_info?Request_ID=${payload.Request_ID}&JobDetails_ID=${payload.JobDetails_ID}`, {
        headers: { "Authorization": `Bearer ${token}` },
    });

export const getRequestStats = (token) =>
    appclient.get(`resupply_satus_count`, {
        headers: { "Authorization": `Bearer ${token}` },
    });

export const getPriorityList = (token) =>
    appclient.get(`get_priority`, {
        headers: { "Authorization": `Bearer ${token}` },
    });

export const getRequestBasicInfo = (token, hs_deal_id) =>
    appclient.get(`All_Deals_details?HS_Deal_ID=${hs_deal_id}`, {
        headers: { "Authorization": `Bearer ${token}` },
    });


export const exportResupply = (token, payload) => {
    const queryParams = Object.entries({
        job_details_id: payload?.job_details_id,
        request_id: payload?.request_id,
        date_range: payload?.date_range,
        job_name: payload?.job_name,
        priority: payload?.priority,
        status: payload?.status,
    })
        .filter(([_, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

    return appclient.get(`resupply_export_resupply_ops?${queryParams}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const updateReSupplyRequest = (payload, token) =>
    appclient.post(`update_request`, payload,
        { headers: { "Authorization": `Bearer ${token}` } });


export const getJobDetails = (token, id) =>
    appclient.get(`Activejobdashboardapi?hs_object_id=${id}`, {
        headers: { "Authorization": `Bearer ${token}` },
    });